module.exports = __webpack_public_path__ + "static/media/install04.c4e4ee0e.png";